<rt-infobox
  [isDismissible]="isDismissible"
  [storageKey]="storageKey"
  [type]="'error'"
  [iconName]="'error'"
  [heading]="'app.settings.admin_profile.mailbox_connection_error.title_1' | translate"
  [buttons]="showButtons ? buttons : []"
>
  <div layout layout-wrap>
    <div class="text">
      {{
        (showButtons
          ? 'app.settings.admin_profile.mailbox_connection_error.desc_with_settings'
          : 'app.settings.admin_profile.mailbox_connection_error.desc'
        ) | translate
      }}
      <a [href]="'app.support_resources.mailbox_connection_issues' | translate" target="_blank">
        {{ 'app.settings.admin_profile.mailbox_connection_error.link_label' | translate }}</a
      >
    </div>
  </div>
</rt-infobox>
